export class Competitor {
  id: number | null = null;
  guid: string | null = null;
  name: string | null = null;
  country: any = [];
  createdAt: string | null = null;
}
